import axios from 'axios';
import { generarHTMLTicket } from './formatoNavegador'; // <--- IMPORTAMOS EL DISEÑO
// Importamos el config solo para los datos, pero creamos una ruta local para la impresora

// 🚩 ESTA ES LA URL DEL PYTHON QUE CORRE EN LA CAJA
const LOCAL_PRINT_URL = "http://127.0.0.1:3001";

const CONFIG = {
    MODO_NAVEGADOR: true,  // Si es true, usa window.print(). Si es false, usa el Python.
    ANCHO_PAPEL: 80,       // 80 o 57
    LOCAL_PRINT_URL: "http://127.0.0.1:3001"
};

// --- FUNCIÓN PARA EL NAVEGADOR (MODO KIOSKO) ---
const imprimirEnNavegador = (html) => {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none'; // No se ve en pantalla
    document.body.appendChild(iframe);
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(html);
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print(); // Dispara la impresión silenciosa si Chrome está en modo kiosko

    // Limpiamos el iframe después de 2 segundos
    setTimeout(() => document.body.removeChild(iframe), 2000);
};


// Función central para hablar con el Python local
async function enviarAPrintService(tipo, pedido) {
    const url = `${LOCAL_PRINT_URL}/api/imprimir/ticket`;
    
    console.log(`🖨️ [LOCAL PRINT] Intentando imprimir ${tipo} en: ${url}`);

    try {
        const res = await axios.post(url, {
            tipo: tipo,       
            contenido: pedido 
        });
        
        console.log(`✅ [LOCAL PRINT] Éxito ${tipo}:`, res.data);
        return res.data;

    } catch (e) {
        if (e.response) {
            console.error(`❌ [LOCAL PRINT] Error del Python (${tipo}):`, e.response.status);
        } else {
            // Este es el error más común: El Python no está abierto
            console.error(`❌ [LOCAL PRINT] ¡EL SERVICIO DE IMPRESIÓN ESTÁ APAGADO!`);
            console.error(`Asegúrate de que 'app.py' esté corriendo en localhost:3001`);
        }
        return null;
    }
}

// --- EXPORTACIONES ---

export async function imprimirComandaCocina(pedido) {
    return await enviarAPrintService('COMANDA', pedido);
}

export async function imprimirReciboCliente(pedido) {
    return await enviarAPrintService('RECIBO', pedido);
}

export async function imprimirReporteZ(data, resumen, cuadros, ranking , usuarios) {
   
     const payload = { 
        data, 
        resumen, 
        cuadros, 
        ranking, 
        ventas_por_usuario: usuarios 
    };
    return await enviarAPrintService('REPORTE_Z', payload);

}

export async function imprimirDocumento(contenidoJSON) {
    return await enviarAPrintService('GENERICO', contenidoJSON);
}

export async function imprimirStockCritico(listaProductos) {
    return await enviarAPrintService('STOCK_CRITICO', listaProductos);
}

export async function imprimirPrecuenta(contenido) {
    return await enviarAPrintService('PRECUENTA', contenido);
}

// Función para el TPV que agrupa cocina y recibo
// --- LA FUNCIÓN MAESTRA QUE USA EL TPV ---
// En tu archivo de servicios de impresión
export const ejecutarImpresionTPV = async (pedido, modo = 'TODO', ajustes = {}) => {
    
    // 🚩 EL SWITCH MAESTRO
    // Detectamos si el servicio de impresión (Python) está activo en la BD
    const usarPython = (ajustes.serv_imp === 1 || ajustes.serv_imp === true);
    
    // Definimos el ancho (80mm o 57mm)
    const anchoPapel = (ajustes.imp_80 === 1 || ajustes.imp_80 === true) ? 80 : 58;

    console.log(`🚀 [ORDEN #${pedido.display_id}]`);
    console.log(`📡 MODO: ${usarPython ? 'SERVICIO PYTHON' : 'NAVEGADOR'}`);

    // --- CAMINO A: SERVICIO PYTHON (AXIOS) ---
    if (usarPython) {
        if (modo === 'TODO' || modo === 'SOLO_COMANDA') {
            console.log("🐍 Enviando Comanda a Python...");
            await imprimirComandaCocina(pedido);
        }
        
        if (modo === 'TODO' || modo === 'SOLO_RECIBO') {
            // Un pequeño delay para que el spooler de Windows no se bloquee
            setTimeout(async () => {
                console.log("🐍 Enviando Recibo a Python...");
                await imprimirReciboCliente(pedido);
            }, 800);
        }
    } 
    
    // --- CAMINO B: NAVEGADOR (HTML/IFRAME) ---
    else {
        if (modo === 'TODO' || modo === 'SOLO_COMANDA') {
            console.log("🖥️ Imprimiendo Comanda en Navegador...");
            const htmlComanda = generarHTMLTicket('COMANDA', pedido, anchoPapel);
            imprimirEnNavegador(htmlComanda);
        }

        if (modo === 'TODO' || modo === 'SOLO_RECIBO') {
            setTimeout(() => {
                console.log("🖥️ Imprimiendo Recibo en Navegador...");
                const htmlRecibo = generarHTMLTicket('RECIBO', pedido, anchoPapel);
                imprimirEnNavegador(htmlRecibo);
            }, 1200); // Un poco más de delay para el navegador
        }
    }
};
